





































import { Component, Vue, Prop } from "vue-property-decorator";
import FarmOwnerInfo from "@/components/farmOwnerInfo/FarmOwnerInfo.vue";
import { Analysis } from "@/api/analyses/types";
import AgroIcons from "@/components/agroIcons/AgroIcons.vue";

@Component({
  name: "CompareFarmsOwnersController",
  components: {
    FarmOwnerInfo,
    AgroIcons,
  },
})
export default class CompareFarmsOwnersController extends Vue {

  @Prop(Object)
  private analysis?: Analysis;

  @Prop({ type: String, default: "" }) private source?: string;

  get showSeasonToggle(): boolean {
    return !!this.analysis && !!this.analysis.unified;
  }

  get harvestSeason(): string {
    const value = this.$route.query.harvestSeason;
    if (value === 'SUMMER' || value === 'WINTER') return value;
    return this.analysis ? this.analysis.harvestSeason : 'SUMMER';
  }

  set harvestSeason(value: string) {
    if (this.$route.query.harvestSeason === value) return;
    this.$router.replace({
      query: { ...this.$route.query, harvestSeason: value },
    }).catch(() => {});
  }

}
